import React, { FC, memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Organization } from '../../../../api/api';
import { saveOrganization, updateOrganization } from '../../../../state/features/organization/operation';
import { AppState } from '../../../../state/store';
import { usePrevious } from '../../../../utilities/use-previous-hook';
import { Form } from '../../../components/default-components/form/form';
import { RightSideContainer } from '../../../components/specific-components/containers/right-side-container';
import { useRightSidebar } from '../../../components/specific-components/right-side-bar';
import { OrganizationForm } from './organization-form';

interface PropsFromParent {
  existingOrganization?: Organization;
}

export const CreateOrganizationForm: FC<PropsFromParent> = memo(({ existingOrganization }) => {
  const dispatch = useDispatch();
  const setSidebarContent = useRightSidebar();
  const { pending, isSuccess } = useSelector((store: AppState) => store.organizationReducer);

  const prevProp = usePrevious(isSuccess);
  // Direct to overview after saving. (We do this due to race condition between save and getAll)
  useEffect(() => {
    if (prevProp !== undefined && isSuccess && !prevProp) {
      setSidebarContent(null);
    }
  }, [pending, isSuccess, prevProp, setSidebarContent]);

  const handleSubmit = useCallback(
    (data: Organization) => {
      if (existingOrganization) {
        dispatch(updateOrganization(data));
      } else {
        dispatch(saveOrganization(data));
      }
    },
    [dispatch, existingOrganization],
  );

  return (
    <RightSideContainer>
      <Form maxHeight onSubmit={handleSubmit}>
        <OrganizationForm existingOrganization={existingOrganization} />
      </Form>
    </RightSideContainer>
  );
});
